export function inputStatusLabel(status, en = false) {
  const labels = {
    queued: ['В очереди', 'Queued'],
    dispatching: ['Передаётся', 'Dispatching'],
    accepted: ['Принято, применение ещё не подтверждено', 'Accepted, not yet confirmed applied'],
    applied: ['Применено', 'Applied'],
    unconfirmed: ['Применение не подтверждено', 'Application unconfirmed'],
    error: ['Ошибка', 'Error'],
    failed: ['Не доставлено', 'Delivery failed'],
    cancelled: ['Отменено', 'Cancelled'],
    paused: ['Приостановлено', 'Paused'],
  };
  return (labels[status] || ['Статус неизвестен', 'Unknown status'])[en ? 1 : 0];
}

export function canChangeInput(input) {
  return ['queued', 'paused'].includes(input?.status);
}

export function canQueueLiveInput(snapshot, run) {
  return snapshot?.loaded === true && snapshot.capabilities?.queue === true && (!run?.active
    || (run.transport === 'live' && run.liveAdmitted === true
      && [snapshot.runId, snapshot.activeRunId].includes(run.liveRunId)));
}

export function canEditInput(input) {
  return canChangeInput(input) && input.mode === 'queue' && !input.execution_run_id && input.message_id == null
    && Number.isInteger(input.revision) && input.revision >= 0;
}

export function inputEditIssue(input, edit) {
  if (!edit) return '';
  if (!canEditInput(input) || edit.error === 'edit_dispatched') return 'edit_dispatched';
  if (input.revision !== edit.expectedRevision && input.text !== edit.text) return 'edit_conflict';
  return edit.error || '';
}

export function hasPendingInputChain(snapshot) {
  return !!snapshot?.activeRunId || !!snapshot?.inputs?.some(input => input.mode === 'queue'
    && ['queued', 'dispatching', 'accepted'].includes(input.status));
}

export function liveInputNotice(code, en = false) {
  const labels = {
    media: ['Во время ответа можно отправить только текст. Вложения сохранены в черновике.', 'Only text can be sent during a response. Attachments remain in the draft.'],
    unavailable: ['Отправка в этот ответ пока недоступна. Черновик сохранён.', 'Sending into this response is not available. Your draft is kept.'],
    loading: ['Проверяем очередь', 'Checking queue'],
    offline: ['Не удалось обновить очередь. Показан последний полученный статус.', 'Could not refresh the queue. Showing the last received status.'],
    failed: ['Не удалось подтвердить действие. Обновите очередь перед повтором.', 'Could not confirm the action. Refresh the queue before retrying.'],
    draft: ['Не удалось сохранить черновик для перезагрузки. Не закрывайте эту вкладку.', 'The draft could not be saved for reload. Keep this tab open.'],
    restoring: ['Восстанавливаем вложения', 'Restoring attachments'],
    length: ['Максимум 24 000 символов. Черновик сохранён.', 'Maximum 24,000 characters. Your draft is kept.'],
    conflict: ['Состояние очереди изменилось. Проверьте обновлённый статус.', 'The queue changed. Check the refreshed status.'],
    edit_conflict: ['Текст изменён на сервере. Ваша правка сохранена локально.', 'The message changed on the server. Your edit is kept locally.'],
    edit_dispatched: ['Сообщение больше нельзя изменить. Ваша правка сохранена локально.', 'This message can no longer be edited. Your edit is kept locally.'],
    edit_failed: ['Не удалось подтвердить сохранение. Правка сохранена локально.', 'Could not confirm the save. Your edit is kept locally.'],
    edit_empty: ['Сообщение не может быть пустым.', 'The message cannot be empty.'],
    media_read: ['Не удалось сохранить вложения. Они остались в поле ввода. Попробуйте ещё раз.', 'Could not save the attachments. They remain in the composer. Try again.'],
    recall_storage_failed: ['Не удалось сохранить возврат сообщения. Не закрывайте вкладку и попробуйте ещё раз.', 'Could not save the message recovery. Keep this tab open and try again.'],
    recall_files_failed: ['Не удалось вернуть вложения. Проверьте соединение и повторите редактирование.', 'Could not restore the attachments. Check your connection and retry editing.'],
    recall_restore_failed: ['Сообщение снято с очереди, но черновик ещё не восстановлен. Нажмите редактировать ещё раз.', 'The message was removed from the queue, but its draft has not been restored. Click edit again.'],
    recall_unconfirmed: ['Возврат сообщения пока не подтверждён. Проверьте соединение и повторите редактирование.', 'Message recall is not confirmed yet. Check your connection and retry editing.'],
    recall_conflict: ['Сообщение в очереди изменилось. Проверьте новый текст перед редактированием.', 'The queued message changed. Check its updated text before editing.'],
    recall_dispatched: ['Модель уже начала обрабатывать это сообщение. Его больше нельзя вернуть из очереди.', 'The model already started processing this message. It can no longer be recalled.'],
  };
  return (labels[code] || labels.failed)[en ? 1 : 0];
}
